module.exports = __webpack_public_path__ + "img/17_57.37939753.png";